import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSeo } from "@/lib/seo";

const META = {
  title: "Pagina non trovata | Magit S.r.l.",
  description: "La pagina richiesta non esiste o è stata spostata.",
  noindex: true,
};

export default function NotFound() {
  useSeo(META);
  return (
    <main data-testid="not-found-page" className="flex min-h-[80vh] items-center pt-[116px] md:pt-[72px]">
      <div className="mx-auto w-full max-w-[1600px] px-6 py-24 md:px-12">
        <p className="font-display text-sm font-bold uppercase tracking-[0.28em] text-brand">Errore 404</p>
        <h1 className="mt-6 font-display text-5xl font-extrabold uppercase leading-[0.9] text-white md:text-8xl">
          Pagina non trovata<span className="text-brand">.</span>
        </h1>
        <p className="mt-6 max-w-xl text-base text-white/60">
          L'indirizzo che hai cercato non esiste o è stato spostato. Puoi tornare alla home o consultare i nostri servizi.
        </p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link to="/" data-testid="not-found-home-link" className="inline-flex items-center justify-center gap-3 rounded-md bg-brand px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-white hover:bg-brand-hover">
            Torna alla home <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to="/servizi" data-testid="not-found-services-link" className="inline-flex items-center justify-center rounded-md border border-white/20 px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-white hover:border-white/50">
            I nostri servizi
          </Link>
        </div>
      </div>
    </main>
  );
}
